<template>
  <div class="loading" :class="{ 'show-overlay': showOverlay }">
    <clip-loader color="#FF6A10" size="70px" />
  </div>
</template>
<script setup lang="ts">
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import './loading.pcss';

withDefaults(
  defineProps<{
    showOverlay?: boolean;
  }>(),
  {
    showOverlay: true,
  }
);
</script>
